import React, { FC } from 'react';
import { Card, CardContent, Skeleton, Box } from '@mui/material';

type SkeletonCardProps = {
    hasAvatar?: boolean;
    hasTitle?: boolean;
    hasSubtitle?: boolean;
    textLines?: number;
    hasActions?: boolean;
    height?: number | string;
    width?: number | string;
};

const SkeletonCard: FC<SkeletonCardProps> = ({
    hasAvatar = false,
    hasTitle = true,
    hasSubtitle = false,
    textLines = 2,
    hasActions = false,
    height,
    width = '100%',
}) => {
    return (
        <Card sx={{ width, height }}>
            <CardContent>
                {hasAvatar && (
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                        <Box sx={{ flex: 1 }}>
                            <Skeleton variant="text" width="60%" height={24} />
                            {hasSubtitle && <Skeleton variant="text" width="40%" height={20} />}
                        </Box>
                    </Box>
                )}

                {!hasAvatar && hasTitle && (
                    <Skeleton variant="text" width="70%" height={28} sx={{ mb: hasSubtitle ? 1 : 2 }} />
                )}

                {!hasAvatar && hasSubtitle && <Skeleton variant="text" width="50%" height={20} sx={{ mb: 2 }} />}

                {textLines > 0 &&
                    Array.from({ length: textLines }).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="text"
                            width={index === textLines - 1 ? '80%' : '100%'}
                            height={20}
                            sx={{ mb: 1 }}
                        />
                    ))}

                {hasActions && (
                    <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                        <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default SkeletonCard;
